export default __webpack_public_path__ + "static/media/icon_video.316c909d.svg";